import React from 'react';
import {Image, View} from 'react-native';
import styled from 'styled-components/native';
import {IsHRWeb} from '../../Tools/DisplayTools';

const LogoWrap = styled.View`
  margin-left: 28px;
  margin-right: 46px;
  height: 50px;
  min-width: 40px;
`;

const Logo = (props) => {
  let base = '';
  if (IsHRWeb() == false) {
    base = global.baseURL;
  }
  return (
    <LogoWrap>
      {global.userData.companylogo !== '' &&
        global.userData.companylogo !== undefined && (
          <>
            {IsHRWeb() && (
              <img
                style={{height: 50}}
                src={base + global.userData.companylogo}
                alt="Logo"
              />
            )}
            {IsHRWeb() == false && (
              <Image
                style={{height: 50}}
                source={{uri: base + global.userData.companylogo}}
                alt="Logo"
              />
            )}
          </>
        )}
    </LogoWrap>
  );
};

export default Logo;
